import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class SetHasImportableCards extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetHasImportableCards';

    public constructor(public hasImportableCards: boolean) {
        super(SetHasImportableCards.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: SetHasImportableCards): void => {
    state.hasImportableCards = action.hasImportableCards;
};

//@ts-ignore
registerReducer(SetHasImportableCards.ACTION_TYPE, reducer);
